import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getAccountConfigs() {
    return {
        palette: {
            [PALETTE_IDS.ACCOUNT_POPOVER]: {
                ACCOUNT_POPOVER_BG: COLOR.BRAND.BACKGROUND1,
                ACCOUNT_BALANCE_LABEL_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    fontSize: FONT.SIZE_XSMALL,
                },
                ACCOUNT_BALANCE_TOTAL_DATA_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                ACCOUNT_ADDITIONAL_LINK_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
            },
            [PALETTE_IDS.MY_ACCOUNT_DIALOG]: {
                MY_ACCOUNT_DIALOG_HEADER_BG: COLOR.BRAND.BACKGROUND7,
                MY_ACCOUNT_DIALOG_HEADER_TEXT: COLOR.BRAND.BACKGROUND1,
                MY_ACCOUNT_DIALOG_TAB_BUTTON_BG: COLOR.BRAND.BACKGROUND7,
                MY_ACCOUNT_DIALOG_TAB_BUTTON_SELECTED_BG: COLOR.BRAND.BACKGROUND1,
                MY_ACCOUNT_DIALOG_TAB_BUTTON_TEXT: {
                    color: `${COLOR.BRAND.BACKGROUND1}|${COLOR.BRAND.BACKGROUND7}`,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
            },
            [PALETTE_IDS.MY_ACCOUNT_PAGE]: {
                MY_ACCOUNT_PAGE_MENU_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    textTransform: 'capitalize',
                },
                MY_ACCOUNT_PAGE_MENU_LINK_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
            },
        },
    };
}
